// extracted by mini-css-extract-plugin
module.exports = {"root":"_9961bf"};